import type { Locale } from "@/lib/i18n";
import { pl, type AccessibilityToggleTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const accessibilityToggleTranslations: Record<Locale, AccessibilityToggleTranslations> = {
  pl,
  en,
  de,
};

export type { AccessibilityToggleTranslations };
